import { DatePipe, DecimalPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export type WfPropertyType = 'string' | 'date' | 'datetime' | 'number';

export interface WfPropertyListEntry {
  key: string;
  value: unknown;
  type?: WfPropertyType;
}

@Component({
  selector: 'wf-property-list',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [DatePipe, DecimalPipe, TranslateModule],
  templateUrl: './property-list.component.html',
  styleUrl: './property-list.component.scss',
  host: { class: 'wf-property-list' },
})
export class WfPropertyListComponent {
  readonly entries = input.required<readonly WfPropertyListEntry[]>();
}
